import { render, staticRenderFns } from "./DashboardSlcPrep.vue?vue&type=template&id=575488d6&scoped=true"
import script from "./DashboardSlcPrep.vue?vue&type=script&lang=js"
export * from "./DashboardSlcPrep.vue?vue&type=script&lang=js"
import style0 from "./DashboardSlcPrep.vue?vue&type=style&index=0&id=575488d6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575488d6",
  null
  
)

export default component.exports